import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Slide from "@material-ui/core/Slide";
import { withNotification } from "../../../notification/context";

const CREATE = gql`
  mutation createContainer(
    $container: ContainerInput!
    $resourceFieldName: String!
    $files: [Upload!]!
  ) {
    createContainer(
      container: $container
      files: $files
      resourceFieldName: $resourceFieldName
    ) {
      id
      name
      layer
      status
    }
  }
`;

const styles = theme => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2
  },
  appBar: {
    position: "relative"
  },
  flex: {
    flex: 1
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  fileZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    padding: theme.spacing.unit
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const CreateItemLayer = ({ classes, openNotification, query, layer }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={CREATE}
      update={(cache, { data: { createContainer } }) => {
        const { containersByLayer } = cache.readQuery({
          query,
          variables: { layer }
        });
        cache.writeQuery({
          query,
          variables: { layer },
          data: {
            containersByLayer: containersByLayer.concat([createContainer])
          }
        });
      }}
    >
      {(createContainer, { loading }) => (
        <Formik
          initialValues={{
            name: "",
            resourceFieldName: "",
            dbfile: null,
            shapefile: null
          }}
          onSubmit={(values, { resetForm }) => {
            createContainer({
              variables: {
                container: {
                  name: values.name,
                  layer
                },
                resourceFieldName: values.resourceFieldName,
                files: [values.dbfile, values.shapefile]
              }
            })
              .then(() => {
                openNotification("contenedor creado correctamente.");
                resetForm();
                handleClose();
              })
              .catch(() => {
                openNotification("Error creando el contenedor");
                //handleClose();
              });
          }}
        >
          {({
            values,
            errors,
            setFieldValue,
            touched,
            handleChange,
            handleSubmit
          }) => {
            return (
              <Form>
                <Tooltip title="Crear contenedor" placement="left">
                  <Fab
                    className={classes.fab}
                    color="primary"
                    onClick={handleClickOpen}
                  >
                    <AddIcon />
                  </Fab>
                </Tooltip>
                <Dialog
                  TransitionComponent={Transition}
                  open={open}
                  onClose={handleClose}
                >
                  <AppBar className={classes.appBar}>
                    <Toolbar>
                      <IconButton
                        color="inherit"
                        onClick={handleClose}
                        aria-label="Close"
                      >
                        <CloseIcon />
                      </IconButton>
                      <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.flex}
                      >
                        Crear contenedor
                      </Typography>
                      <Button color="inherit" onClick={handleSubmit}>
                        Guardar
                      </Button>
                    </Toolbar>
                  </AppBar>
                  <DialogContent>
                    <Row style={{ marginRight: 10 }} center="xs">
                      <Col xs={12}>
                        <TextField
                          required
                          name="name"
                          id="outlined-name"
                          label="Nombre"
                          className={classes.textField}
                          value={values.name}
                          onChange={handleChange}
                          margin="normal"
                          variant="outlined"
                          error={errors.name && touched.name && errors.name}
                          fullWidth
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Col>
                      <Col xs={12}>
                        <TextField
                          required
                          name="resourceFieldName"
                          id="outlined-name"
                          label="Campo de nombre de recurso"
                          className={classes.textField}
                          value={values.resourceFieldName}
                          onChange={handleChange}
                          margin="normal"
                          variant="outlined"
                          error={
                            errors.resourceFieldName &&
                            touched.resourceFieldName &&
                            errors.resourceFieldName
                          }
                          fullWidth
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                      </Col>
                      <Col xs={12}>
                        <div className={classes.fileZone}>
                          <input
                            className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-dbfile"
                            type="file"
                            accept=".dbf"
                            onChange={({
                              target: {
                                files: [file]
                              }
                            }) => {
                              setFieldValue("dbfile", file);
                            }}
                          />
                          <label htmlFor="raised-button-dbfile">
                            <Button
                              size="large"
                              variant="contained"
                              component="span"
                              className={classes.margin}
                              disabled={loading}
                            >
                              Seleccionar archivo dbf...
                              <CloudUploadIcon className={classes.rightIcon} />
                            </Button>
                          </label>
                          {errors.dbfile && touched.dbfile && (
                            <p>{errors.dbfile}</p>
                          )}
                          <Typography variant="body1">
                            {values.dbfile
                              ? `Seleccionado: ${values.dbfile.name}`
                              : "Ningun archivo seleccionado ..."}
                          </Typography>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className={classes.fileZone}>
                          <input
                            className={classes.input}
                            style={{ display: "none" }}
                            id="raised-button-shapefile"
                            accept=".shp"
                            type="file"
                            onChange={({
                              target: {
                                files: [file]
                              }
                            }) => {
                              setFieldValue("shapefile", file);
                            }}
                          />
                          <label htmlFor="raised-button-shapefile">
                            <Button
                              size="large"
                              variant="contained"
                              component="span"
                              className={classes.margin}
                              disabled={loading}
                            >
                              Seleccionar archivo shp...
                              <CloudUploadIcon className={classes.rightIcon} />
                            </Button>
                          </label>
                          {errors.shapefile && touched.shapefile && (
                            <p>{errors.shapefile}</p>
                          )}
                          <Typography variant="body1">
                            {values.shapefile
                              ? `Seleccionado: ${values.shapefile.name}`
                              : "Ningun archivo seleccionado ..."}
                          </Typography>
                        </div>
                      </Col>
                    </Row>
                  </DialogContent>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      )}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(CreateItemLayer);



// WEBPACK FOOTER //
// ./src/components/admin/carto/containers/add-item-button.js